import SampleReportView from "@/components/samples/SampleReportView";
import { SOLAR_LANDSCAPE_REPORT } from "@/data/sample-reports";

const SolarLandscapeSample = () => <SampleReportView report={SOLAR_LANDSCAPE_REPORT} />;

export default SolarLandscapeSample;
